export default "__VITE_ASSET__Bmqj3vwT__"